const mutations = {
  onGetAll (state, payload) {
    payload.event.context.incidents = payload.response.data.data.inspections
    payload.event.context.options.itemsPerPage = parseInt(payload.response.data.data.per_page)
    payload.event.context.options.page = payload.response.data.data.current_page
    payload.event.context.options.total = payload.response.data.data.total
    payload.event.context.loadTable = false
  },
  onGetById (state, payload) {
    payload.event.context.loadItem = false
    payload.event.context.incident = payload.response.data.data
  },
  onGetGalleryReport (state, payload) {
    if (payload.event.type === 'json') {
      payload.event.context.loadGallery = false
      payload.event.context.gallery = payload.response.data.data.data
    } else {
      payload.event.context.forceFileDownload(payload.response.data, 'GalleryIncidents.zip')
      payload.event.context.loadButton = false
    }
  },
  onGetGallery (state, payload) {
    payload.event.context.loadByID = false
    payload.event.context.galleryID = payload.response.data.data.data
    payload.event.context.actualPage = payload.response.data.data.data[0].issues.current_page
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loadItem = false
    payload.event.context.loadTable = false
    payload.event.context.loadGallery = false
    payload.event.context.loadButton = false
    payload.event.context.loadByID = false

  }
}

export default mutations